export const PEEPOSPRINT_COLLECTION = 'peepoSprint';
export const MAPS_COLLECTION = 'maps';
export const LOGS_COLLECTION = 'logs';
export const QUALIFIER_COLLECTION = 'qualifier';
export const QUALIFIER_LEADERBOARD_ID = 'qualifier';
export const LEADERBOARDS_COLLECTION = 'leaderboards';
export const CONFIG_DOC = 'config';
